// Copy for the "Cargar direcciones" flow, keyed by the error name the API sends
// (POST /tasks/by-channel-intake). Never the API message on a 5xx.

const BY_NAME = {
  CaseNotVerified:
    'La causa todavía no está verificada en PJUD. Reintenta cuando termine.',
  TaskAlreadyRunning: 'La causa ya tiene una diligencia viva.',
  TaskDispatchInProgress:
    'Se está despachando, vuelve a intentar en unos segundos.',
  ChannelReceptorsNotAllowlisted:
    'Ningún receptor de la corte está en la lista QA.',
};

export const NOT_FOUND_TEXT =
  'El pedido no vinculó una causa, no es de este canal o el seguimiento ya tiene como origen otro pedido.';
export const FORBIDDEN_TEXT =
  'Tu usuario no tiene el permiso para cargar las direcciones.';
export const SERVER_TEXT =
  'No se pudo confirmar la creación. Reintenta: si ya se creó, se retoma.';
const TITLE = 'No se pudo crear la diligencia';

// A name the panel answers by re-reading the intake: the live diligence is
// what stands in the way, so it is shown instead of the form.
export const REFETCH_ON = ['TaskAlreadyRunning'];

// `{ title, message }` for the toast.
export function diligenceFailure(error, name) {
  if (BY_NAME[name]) return { title: TITLE, message: BY_NAME[name] };
  const status = error?.status;
  if (status === 403) return { title: TITLE, message: FORBIDDEN_TEXT };
  if (status === 404) return { title: TITLE, message: NOT_FOUND_TEXT };
  if (typeof status !== 'number' || status >= 500) {
    return { title: TITLE, message: SERVER_TEXT };
  }
  return { title: TITLE, message: error?.message || SERVER_TEXT };
}

export const STAGE_LABEL = {
  DRAFT: 'Borrador',
  QUOTING: 'Cotizando',
  PAYMENT_DUE: 'Pago pendiente',
  PAYMENT_PROCESSING: 'Pago en proceso',
  PAYMENT_REJECTED: 'Pago rechazado',
  IN_PROGRESS: 'En curso',
};
